import { sortBy } from "lodash";
import { defaultMapper } from "./user-settings";
import { SortByTypes } from "store/current-dashboard/types";
export const sortData = (data, sortedBy, isEsgData, valueSelectors = defaultMapper) => {
    if (isEsgData && sortedBy === SortByTypes.Name) {
        return data.sortESG(valueSelectors[sortedBy]);
    }
    if (sortedBy === SortByTypes.Value) {
        return sortBy(data, valueSelectors[sortedBy]).reverse();
    }
    return sortBy(data, valueSelectors[sortedBy]);
};
